import { useEffect, useState } from "react";
import { Lock } from "lucide-react";
import { useApp } from "@/context/AppContext";
import { PageHeader, Panel, Loading, Empty, Th, Td, TableWrap } from "@/components/kit";
import { dmyTime } from "@/lib/format";

export default function Audit() {
  const { api, t } = useApp();
  const [rows, setRows] = useState(null);
  useEffect(() => { api.get("/audit").then((r) => setRows(r.data)); }, [api]);
  return (
    <>
      <PageHeader eyebrow={t("audit")} title={t("audit")}>
        <span className="flex items-center gap-1.5 text-xs text-slate-500"><Lock className="h-3.5 w-3.5" />Lecture seule · non modifiable</span>
      </PageHeader>
      <Panel>
        {!rows ? <Loading /> : rows.length === 0 ? <Empty /> : (
          <TableWrap>
            <thead className="border-b"><tr><Th>{t("date")}</Th><Th>Utilisateur</Th><Th>Action</Th><Th>Objet</Th><Th>Détails</Th></tr></thead>
            <tbody>{rows.map((a) => (
              <tr key={a.id} className="border-b border-slate-50" data-testid="audit-row">
                <Td className="num text-xs whitespace-nowrap">{dmyTime(a.at)}</Td><Td className="text-xs">{a.email || "système"}</Td>
                <Td><span className={`rounded px-1.5 py-0.5 text-xs font-semibold ${a.action === "support_access" ? "bg-orange-100 text-orange-800" : "bg-slate-100 text-slate-700"}`}>{a.action}</span></Td>
                <Td className="text-xs">{a.entity}</Td><Td className="num text-[11px] text-slate-500 max-w-[360px] truncate">{JSON.stringify(a.details)}</Td>
              </tr>))}</tbody>
          </TableWrap>
        )}
      </Panel>
    </>
  );
}
